import { useState } from 'react';
import { initialForm } from '../services/playerService';

const MAX_ITEMS = 20;

export const usePlayerForm = () => {
  const [formData, setFormData] = useState(initialForm);
  const [statusMessage, setStatusMessage] = useState('');
  const [createdProfile, setCreatedProfile] = useState(null);

  const handleChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const toggleSkillTag = (tag) => {
    setFormData((prev) => {
      const exists = prev.skills.skillTags.includes(tag);
      const updated = exists
        ? prev.skills.skillTags.filter((item) => item !== tag)
        : [...prev.skills.skillTags, tag];

      return {
        ...prev,
        skills: {
          ...prev.skills,
          skillTags: updated,
        },
      };
    });
  };

  const toggleExtraFeature = (feature) => {
    setFormData((prev) => {
      const exists = prev.extraFeatures.includes(feature);
      const updated = exists
        ? prev.extraFeatures.filter((item) => item !== feature)
        : [...prev.extraFeatures, feature];

      return {
        ...prev,
        extraFeatures: updated,
      };
    });
  };

  const toggleAddOn = (addOnKey, label) => {
    setFormData((prev) => {
      const enabled = !prev.addOns?.[addOnKey];
      const nextExtra = enabled
        ? Array.from(new Set([...(prev.extraFeatures || []), label]))
        : (prev.extraFeatures || []).filter((item) => item !== label);

      const nextPreferences = { ...(prev.preferences || {}) };
      if (addOnKey === 'joinTeamsEnabled') {
        nextPreferences.openToTeams = enabled;
      }
      if (addOnKey === 'joinTournamentsEnabled') {
        nextPreferences.openToTournaments = enabled;
      }

      return {
        ...prev,
        addOns: {
          ...(prev.addOns || {}),
          [addOnKey]: enabled,
        },
        preferences: nextPreferences,
        extraFeatures: nextExtra,
      };
    });
  };

  const updateAddOnField = (section, field, value) => {
    setFormData((prev) => {
      if (section === 'matchParticipationSummary') {
        return {
          ...prev,
          matchParticipation: {
            ...(prev.matchParticipation || {}),
            summary: {
              ...((prev.matchParticipation || {}).summary || {}),
              [field]: value,
            },
          },
        };
      }

      return {
        ...prev,
        [section]: {
          ...(prev[section] || {}),
          [field]: value,
        },
      };
    });
  };

  const manageListItem = (section, action, index, field, value) => {
    setFormData((prev) => {
      const list = Array.isArray(prev[section]) ? [...prev[section]] : [];
      if (action === 'add') {
        if (list.length >= MAX_ITEMS) return prev;
        list.push({ id: crypto.randomUUID?.() || `${Date.now()}-${Math.random()}` });
      } else if (action === 'remove') {
        list.splice(index, 1);
      } else if (action === 'change') {
        list[index] = { ...(list[index] || {}), [field]: value };
      } else if (action === 'toggleAdd') {
        if (list.length >= MAX_ITEMS) return prev;
        list.push({ id: value.code, code: value.code, label: value.label, icon: value.icon });
      } else if (action === 'toggleRemove') {
        return { ...prev, [section]: list.filter((item) => item.code !== value.code) };
      }

      return { ...prev, [section]: list };
    });
  };

  const handleFileChange = (section, field, files) => {
    const file = files?.[0] || '';
    handleChange(section, field, file);
  };

  return {
    createdProfile,
    formData,
    handleChange,
    handleFileChange,
    setCreatedProfile,
    setFormData,
    setStatusMessage,
    statusMessage,
    manageListItem,
    toggleAddOn,
    toggleExtraFeature,
    toggleSkillTag,
    updateAddOnField,
  };
};
